/// <amd-module name="Artifacts/Ivy/helpers/IvyFileHelper" />
import { IPackageVersion } from "Artifacts/Root/types/IPackageVersion";

export interface IIvyFile {
  name: string;
  key: string;
}

export function getHrefLink(
  feedId: string,
  normalizedPackageName: string,
  normalizedPackageVersion: string,
  fileName: string,
): string {
  // Hardcoding the link to skype specifically.
  // No project scoped feeds have ivy packages so stripping that out.
  return `https://pkgs.dev.azure.com/skype/_packaging/${feedId}/ivy/v1/${normalizedPackageName}/${normalizedPackageVersion}/${fileName}`;
}

export function getFiles(packageVersion: IPackageVersion): IIvyFile[] {
  const fileNames: IIvyFile[] = [];

  if (packageVersion.files) {
    packageVersion.files.forEach((file) => {
      fileNames.push({
        name: file.name,
        key: file.name,
      });
    });
  }

  return fileNames;
}
